import React, {Component} from 'react';
import {gpn} from "../GPN"
import Back from "../sections/Back";
import Button from "../sections/MUI/Button";
import Field from "../sections/MUI/Field";
import req from "../req";
import {toast} from "react-toastify";
import Icon from "../sections/MUI/Icon";
import config from "../config";
import Modal from "../sections/MUI/Modal";

class Services2 extends Component {

    state = {
        services: null,

        title: "",
        price: "",

        editIndex: -1
    };

    componentDidMount() {
        this.getServices();
    }


    getServices() {
        req.get(`/service2`)
            .then(r => {
                let list = r ? r : [];
                list = list ? list : [];
                this.setState({
                    services: list
                });
            });
    }

    submit() {
        let {title, price} = this.state;
        title = title ? title.toString().trim() : "";
        price = price ? price.toString().trim() : "";
        price = price.replace(/,/g, "").trim();

        if (title !== "" && price !== "") {
            toast.info("در حال ثبت خدمت ...");
            req.post(`/service2`, {title, price})
                .then(r => {
                    if (r) {
                        toast.success("خدمت با موفقیت ثبت شد!");
                        this.getServices();
                        this.setState({
                            title: "",
                            price: ""
                        });
                    }
                });
        } else {
            toast.error("فیلد ها را تکمیل کنید!");
        }
    }

    delete(id = null) {
        id = id ? id : null;

        if (id) {
            toast.info("در حال حذف ...");
            req.delete(`/service2?id=${id}`)
                .then(r => {
                    if (r) {
                        toast.success("با موفقیت حذف شد.");
                        this.getServices();
                    }
                });
        }
    }

    edit() {
        let {services, editIndex} = this.state;
        let {_id, title, price} = services[editIndex];
        title = title ? title.toString().trim() : "";
        price = price ? price.toString().trim() : "";
        price = price.replace(/,/g, "").trim();

        if (title !== "" && price !== "") {
            this.setState({editIndex: -1});
            toast.info("در حال ویرایش ...");
            req.put(`/service2`, {id: _id, title, price})
                .then(r => {
                    if (r) {
                        toast.success("با موفقیت ویرایش شد");
                    }
                });
        } else {
            toast.error("عنوان و مبلغ نمی تواند خالی باشد!");
        }
    }

    handleInputChange(name = "", value = "") {
        let {services, editIndex} = this.state;
        services[editIndex][name] = value;
        this.setState({services});
    }

    render() {
        let {services, title, price, editIndex} = this.state;
        return (
            <div className="services2">

                {editIndex !== -1 ?
                    <Modal display={editIndex !== -1}
                           onCloseClick={() => this.setState({editIndex: -1})}
                           title="ویرایش خدمت">
                        <Field name="title"
                               value={services[editIndex].title}
                               maxLength={350}
                               onChange={(name, value) => this.handleInputChange(name, value)}
                               label="عنوان خدمت"/>
                        <Field name="price"
                               typePrice
                               value={services[editIndex].price.toString()}
                               label="مبلغ (تومان)"
                               style={{direction: "ltr"}}
                               onChange={(name, value) => this.handleInputChange(name, value)}/>

                        <br/>
                        <Button icon="edit" onClick={() => this.edit()}>ویرایش کردن</Button>
                    </Modal>
                    : null}

                <Back {...this.props}/>

                <div className="new">
                    <div className="row">
                        <div className="col-md-5">
                            <Field name="title"
                                   value={title}
                                   maxLength={350}
                                   label="عنوان خدمت"
                                   onChange={(name, value) => this.setState({[name]: value})}/>
                        </div>
                        <div className="col-md-4">
                            <Field typePrice
                                   name="price"
                                   value={price}
                                   maxLength={20}
                                   onChange={(name, value) => this.setState({[name]: value})}
                                   style={{direction: "ltr"}}
                                   label="مبلغ (تومان)"/>
                        </div>
                        <div className="col-md-3">
                            <Button icon="check" onClick={() => this.submit()}>ثبت خدمت</Button>
                        </div>
                    </div>
                </div>

                <div className="list">
                    {services ?
                        services?.length > 0 ?
                            services?.map((s, i) =>
                                <article key={"service" + i}>
                                    <div className="row">
                                        <div className="col-auto">
                                            <span className="sort">{i + 1}-</span>
                                        </div>
                                        <div className="col">
                                            <p className="title">{s.title}</p>
                                            <p className="price">{config.priceFormatter(s.price)}&nbsp;تومان</p>
                                        </div>
                                        <div className="col-auto">
                                            <Icon i="edit" className="edit-icon"
                                                  onClick={() => this.setState({editIndex: i})}/>
                                            <Icon i="trash" className="delete-icon"
                                                  onDoubleClick={() => this.delete(s._id)}/>
                                        </div>
                                    </div>
                                </article>
                            )
                            : <div style={{padding: 16, textAlign: "center"}}>موردی وجود ندارد!</div>
                        : <div style={{padding: 16, textAlign: "center"}}>در حال دریافت ...</div>}
                </div>
            </div>
        );
    }
}

export default gpn(Services2);